import styled from 'styled-components';

const SkeletonStyled = styled.div`
  background-color: #e2e6ea;
  height: auto;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  background: linear-gradient(90deg, #e2e6ea 0%, #fff 40% , #e2e6ea 60% );
  background-size: 200% 100%;
  background-position: 100% 0;
  animation: load 2s infinite;
  width: 100%;
  
  @keyframes load {
    100% {
      background-position: -100% 0;
    }
  }
  
  }
`;

const RoamingContainerStyled = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 5px 10px 0px rgba(14, 20, 29, 0.15);
  gap: 24px;
  align-items: center;
  width: 100%;

  @media (min-width: 769px) {
    padding: 24px 48px 32px 48px;
    gap: 40px;
  }

  & > div:nth-child(1) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;

    & > div:nth-child(1) {
      max-width: 100px;
      height: 100px;

      @media (min-width: 769px) {
        max-width: 80px;
        height: 80px;
      }
    }

    & > div:nth-child(2) {
      max-width: 211px;
      height: 20px;

      @media (min-width: 769px) {
        max-width: 316px;
      }
    }
  }

  & > div:nth-child(2) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 16px;
    width: 100%;
    @media (min-width: 769px) {
      max-width: 384px;
    }

    & > div:nth-child(1) {
      max-width: 118px;
      height: 20px;

      @media (min-width: 769px) {
        max-width: 133px;
      }
    }

    & > div:nth-child(2) {
      width: 100%;
      height: 44px;
      @media (min-width: 769px) {
        max-width: 384px;
      }
    }
  }

  & > div:nth-child(3) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;

    @media (min-width: 769px) {
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }

    & > div:nth-child(1) {
      max-width: 160px;
      height: 20px;
    }

    & > div:nth-child(2) {
      display: grid;
      align-items: center;
      gap: 16px;
      align-self: stretch;
      grid-template-columns: auto;

      @media (min-width: 769px) {
        grid-template-columns: auto auto;
      }

      & > div {
        flex: inherit;
        width: 100%;
        height: 44px;
        align-self: stretch;

        @media (min-width: 769px) {
          height: 64px;
          grid-template-columns: auto auto;
        }
      }
    }

    & > div:nth-child(3) {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 16px;
      width: 100%;
      & > div:nth-child(1) {
        max-width: 115px;
        height: 20px;
      }
    }
  }
`;

const RoamingContainerSkeletonStyled = styled.div`
  width: 100%;
`;

export {
  RoamingContainerStyled,
  SkeletonStyled,
  RoamingContainerSkeletonStyled,
};
